import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ExternalAuthService } from './external-auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminOnlyGuard {
  constructor(
    private externalAuthService: ExternalAuthService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    const role = this.externalAuthService.getCurrentUserInfo()?.role;
    if (role === 'admin' || role === 'it') {
      return true;
    }
    return this.router.parseUrl('/companies/list');
  }
}
